"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bullet_list_1 = require("./bullet-list");
const heading_1 = require("./heading");
const index_1 = require("./index");
const ordered_list_1 = require("./ordered-list");
const paragraph_1 = require("./paragraph");
class Panel extends index_1.TopLevelNode {
    constructor(panelType) {
        super();
        this.panelType = panelType;
        this.content = new index_1.ContentNode('panel');
    }
    heading(level) {
        return this.content.add(new heading_1.Heading(level));
    }
    paragraph() {
        return this.content.add(new paragraph_1.Paragraph());
    }
    orderedList() {
        return this.content.add(new ordered_list_1.OrderedList());
    }
    bulletList() {
        return this.content.add(new bullet_list_1.BulletList());
    }
    toJSON() {
        return Object.assign({}, this.content.toJSON(), { attrs: {
                panelType: this.panelType
            } });
    }
}
exports.Panel = Panel;
//# sourceMappingURL=panel.js.map